import { createFileRoute } from '@tanstack/react-router'
import { AuditorPopulationDetailPage, auditorPopulationSearchSchema } from '@/components/auditor-center/AuditorPopulationsPage'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/populations_/$populationId',
)({
  validateSearch: auditorPopulationSearchSchema,
  component: AuditorPopulationDetailPage,
})
